import { render, staticRenderFns } from "./DrawerCreateEditCategory.vue?vue&type=template&id=854fbf74"
import script from "./DrawerCreateEditCategory.js?vue&type=script&lang=js&external"
export * from "./DrawerCreateEditCategory.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports